module.exports = __webpack_public_path__ + "static/pickup-a1474f15801fbbc0f0b6538a14df7158.png";